import React from 'react';

function NoDataCell(props) {
    const { colSpan, noDataText } = props;

    return <tr><td className="no-data" colSpan={colSpan}>{noDataText}</td></tr>;
}


export default NoDataCell;
